import api from '@/API';
import { AppUser } from '@/type';
import recognition from './recognition';
import appUserStorage from './app-user-storage';

export interface LoginCommand {
  email: string,
  password: string,
  remember: boolean,
}

export interface MFALoginCommand extends LoginCommand {
  pin: string
}

export interface LoginResponse {
  user: AppUser,
  nextAction: 'mfa_one_time_pin'|null
}

export function login(command: LoginCommand): Promise<LoginResponse> {
  return api
    .post('auth/login', command)
    .then((response) => {
      appUserStorage.write(response.data.user);
      return response.data;
    });
}

export function mfaLogin(command: MFALoginCommand): Promise<LoginResponse> {
  return api
    .post('auth/login', command)
    .then(response => response.data);
}

export function mfaResendPin(email: string, password: string): Promise<void> {
  return api
    .post('one-time-pins', { email, password });
}

export function logout(): Promise<void> {
  if (!recognition.isAuthenticated()) return Promise.resolve();
  return api
    .post('auth/logout')
    .then(() => {
      appUserStorage.clear();
    });
}
